module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', [_c('v-col', {
    staticClass: "wrapper-pay"
  }, [
    [_c('span', {
      staticClass: "title-pay sucsess"
    }, [_vm._v("\n        УСПЕШНО ОТПРАВЛЕНО\n      ")]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-pay"
    }, [_vm._v("\n        Отмена приказа успешно отправлена на email судьи\n      ")]), _c('br')], _vm._v(" "), _c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_c('button', {
      staticClass: "red-button"
    }, [_vm._v("\n        Вернуться на главную\n      ")])])
  ], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f7edb2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cancel/inf_page/send.vue
// module id = 346
// module chunks = 2